require('./channels/channelsController');
require('./events/eventsController');
require('../fhApp/date/dateDirective');

"use strict";

angular.module('app.coverage', [
    'app.coverage.channels.channelsController',
    'app.coverage.events.eventsController',
    'app.dateDirective'
])
    .config([
        '$stateProvider',
        function ($stateProvider) {
            return $stateProvider.state('app.coverage', {
                url: '/coverage',
                templateUrl: 'components/coverage/coverageView.html',
                controller: [
                    '$state',
                    function ($state) {

                        if ($state.is('app.coverage')) {
                            return $state.go('app.coverage.channels');
                        }
                    }
                ],
                title: 'Coverage'
            }).state('app.coverage.channels', {
                url: '/channels',
                templateUrl: 'components/coverage/channels/channelsView.html',
                controller: 'app.coverage.channels.channelsController',
                title: 'Channels'
            }).state('app.coverage.events', {
                url: '/events',
                templateUrl: 'components/coverage/events/eventsView.html',
                controller: 'app.coverage.events.eventsController',
                title: 'Events'
            });
        }
    ]);



// WEBPACK FOOTER //
// ./app.v2/components/coverage/coverage.js